import React, { useState } from 'react';
import { MapPin } from 'lucide-react';

const CitiesSection = () => {
  const [activeZone, setActiveZone] = useState('all');

  const bruxellesCommunes = {
    centre: [
      { name: 'Bruxelles-Centre', code: '1000' },
      { name: 'Laeken', code: '1020' },
      { name: 'Neder-Over-Heembeek', code: '1120' },
      { name: 'Haren', code: '1130' }
    ],
    est: [
      { name: 'Ixelles', code: '1050' },
      { name: 'Etterbeek', code: '1040' },
      { name: 'Schaerbeek', code: '1030' },
      { name: 'Saint-Josse', code: '1210' },
      { name: 'Evere', code: '1140' },
      { name: 'Woluwe-Saint-Lambert', code: '1200' },
      { name: 'Woluwe-Saint-Pierre', code: '1150' },
      { name: 'Auderghem', code: '1160' },
      { name: 'Watermael-Boitsfort', code: '1170' }
    ],
    ouest: [
      { name: 'Anderlecht', code: '1070' },
      { name: 'Molenbeek-Saint-Jean', code: '1080' },
      { name: 'Koekelberg', code: '1081' },
      { name: 'Berchem-Sainte-Agathe', code: '1082' },
      { name: 'Ganshoren', code: '1083' },
      { name: 'Jette', code: '1090' }
    ],
    sud: [
      { name: 'Saint-Gilles', code: '1060' },
      { name: 'Forest', code: '1190' },
      { name: 'Uccle', code: '1180' }
    ]
  };

  const getAllCommunes = () => {
    return [
      ...bruxellesCommunes.centre,
      ...bruxellesCommunes.est,
      ...bruxellesCommunes.ouest,
      ...bruxellesCommunes.sud
    ];
  };

  const getFilteredCommunes = () => {
    if (activeZone === 'all') return getAllCommunes();
    return bruxellesCommunes[activeZone] || [];
  };

  return (
    <section className="cities-section">
      <div className="cities-container">
        <div className="cities-header">
          <MapPin className="header-icon" size={40} />
          <h2>Services disponibles dans toute la région de Bruxelles</h2>
          <p className="cities-subtitle">
            Consultations à domicile ou à distance pour toutes les communes de Bruxelles
          </p>
        </div>

        <div className="province-filters">
          <button 
            className={`filter-btn ${activeZone === 'all' ? 'active' : ''}`}
            onClick={() => setActiveZone('all')}
          >
            Toutes les communes
          </button>
          <button 
            className={`filter-btn ${activeZone === 'centre' ? 'active' : ''}`}
            onClick={() => setActiveZone('centre')}
          >
            Bruxelles Centre
          </button>
          <button 
            className={`filter-btn ${activeZone === 'est' ? 'active' : ''}`}
            onClick={() => setActiveZone('est')}
          >
            Bruxelles Est
          </button>
          <button 
            className={`filter-btn ${activeZone === 'ouest' ? 'active' : ''}`}
            onClick={() => setActiveZone('ouest')}
          >
            Bruxelles Ouest
          </button>
          <button 
            className={`filter-btn ${activeZone === 'sud' ? 'active' : ''}`}
            onClick={() => setActiveZone('sud')}
          >
            Bruxelles Sud
          </button>
        </div>

        <div className="cities-grid">
          {getFilteredCommunes().map((commune, index) => (
            <div key={index} className="city-card">
              <MapPin size={20} className="city-icon" />
              <span className="city-name">{commune.name}</span>
              <span className="city-code">({commune.code})</span>
            </div>
          ))}
        </div>

        <div className="coverage-note">
          <p>
            📍 Services disponibles dans toute la région de Bruxelles-Capitale et périphérie
          </p>
        </div>
      </div>
    </section>
  );
};

export default CitiesSection;
